var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_896_33409)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.2193 16.4355H16.7807V18.0452H3.2193V16.4355Z",
    fill: "#897BAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.39035 19.9999C1.72066 19.9999 1.28922 19.2902 1.59738 18.6957L4.76863 12.5781H6.7807L3.18328 19.5178C3.02977 19.8139 2.72395 19.9999 2.39035 19.9999Z",
    fill: "#988FC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.77465 12.5781H4.76859L1.59738 18.6957C1.35883 19.1559 1.56363 19.6848 1.97887 19.9004L5.77465 12.5781Z",
    fill: "#897BAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6096 19.9999C18.2793 19.9999 18.7108 19.2902 18.4026 18.6957L15.2314 12.5781H13.2193L16.8167 19.5178C16.9702 19.8139 17.2761 19.9999 17.6096 19.9999Z",
    fill: "#988FC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2254 12.5781H13.2193L16.8167 19.5178C16.9702 19.8139 17.276 19.9999 17.6097 19.9999C17.7609 19.9999 17.8999 19.9634 18.0211 19.9004L14.2254 12.5781Z",
    fill: "#897BAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9879 15.2185H2.01207C0.90082 15.2185 0 14.3176 0 13.2064V3.21924H20V13.2063C20 14.3176 19.0992 15.2185 17.9879 15.2185Z",
    fill: "#F5F5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.60965 13.2064V3.21924H0V13.2063C0 14.3176 0.90082 15.2184 2.01207 15.2184H3.62172C2.51051 15.2185 1.60965 14.3176 1.60965 13.2064Z",
    fill: "#EBEBF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.01207 13.6088C1.7898 13.6088 1.60965 13.4286 1.60965 13.2063V3.21924H18.3904V13.2063C18.3904 13.4286 18.2102 13.6088 17.9879 13.6088H2.01207Z",
    fill: "#FF9696"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.2193 13.2063V3.21924H1.60965V13.2063C1.60965 13.4286 1.7898 13.6088 2.01207 13.6088H3.62172C3.39949 13.6088 3.2193 13.4286 3.2193 13.2063Z",
    fill: "#FF73A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9879 0H2.01207C0.90082 0 0 0.90082 0 2.01207V3.62172H20V2.01207C20 0.90082 19.0992 0 17.9879 0Z",
    fill: "#FFF48F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.62172 0H2.01207C0.90082 0 0 0.90082 0 2.01207V3.62172H1.60965V2.01207C1.60965 0.90082 2.51051 0 3.62172 0Z",
    fill: "#FFEE6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.03332 6.01926L12.2466 8.23558C12.5371 8.3884 12.5371 8.80429 12.2466 8.95707L8.03332 11.1734C7.80711 11.2924 7.53551 11.1284 7.53551 10.8728V6.31988C7.53551 6.06429 7.80711 5.90027 8.03332 6.01926Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.65348 10.4164V6.77629C8.65348 6.60531 8.80555 6.48613 8.96113 6.50734L8.03328 6.01926C7.80707 5.90027 7.53547 6.06429 7.53547 6.31988V10.8728C7.53547 11.1284 7.80707 11.2924 8.03328 11.1734L8.96113 10.6853C8.80555 10.7066 8.65348 10.5874 8.65348 10.4164Z",
    fill: "#F5F5FC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_896_33409"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.a867758089272039e7244017823cf472.svg";
export { ForwardRef as ReactComponent };